import styled from "styled-components";
import { includeStyledSystem, sx } from "../../util/styledSystem";
export const ModalHeader = styled.div `
  box-sizing: border-box;
  min-width: 0;
  text-align: center;
  position: relative;
  ${({ theme: { space, radii, colors: { modalColors }, }, }) => ({
    backgroundColor: modalColors.modalHeaderBackground,
    borderTopLeftRadius: radii[1],
    borderTopRightRadius: radii[1],
    paddingBottom: space[3],
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: space[3],
})}

  ${includeStyledSystem()}
  ${sx}
`;
